import { Button, ButtonProps, ConfigProvider } from "antd";
import { useAntTheme } from "hooks/useAntTheme";

export const CTAButton = ({ children, ...props }: ButtonProps) => {
  const { theme } = useAntTheme();
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorPrimary: theme.colorBlack,
          },
        },
      }}
    >
      <Button
        type="primary"
        shape="round"
        style={{
          width: "fit-content",
          margin: "auto",
        }}
        {...props}
      >
        {children}
      </Button>
    </ConfigProvider>
  );
};
